import {setArticleDetails} from '../analytics/article-details';
import {publishEvent} from '../analytics/pub-sub';
import {ANALYTIC_EVENTS} from '../analytics/pub-sub/constants';
import {getSimpleObserver} from '../helpers';

const visitedContentTypeIds = {};

const handleSendVisitPage = ({onSend, id, $article}) => {
  if (!visitedContentTypeIds?.[id]) {
    const $headline = $article.querySelector('.js-main-headline');

    if ($headline) {
      getSimpleObserver(() => onSend(id, 'view'), $headline);
    }

    visitedContentTypeIds[id] = true;
  }
};

export default (analyticsData = {}, sendEventPage, referers) => new IntersectionObserver(changes => {
  changes.forEach(change => {
    const {dataset} = change?.target || {};

    if (dataset) {
      const newPathname = dataset.url.replace(/.*\/\/[^\/]*/, '');
      const isSamePathname = newPathname === window.location.pathname;

      setArticleDetails(dataset);
      if (!isSamePathname && change.isIntersecting) {
        const {url, title, id} = dataset;

        window.history?.replaceState({}, title, newPathname);
        let newAnalyticsData = {...analyticsData};

        if (change.boundingClientRect.y > change.rootBounds.y) {
          newAnalyticsData = {...newAnalyticsData, referer: referers?.prev};
        } else {
          newAnalyticsData = {...newAnalyticsData, referer: referers?.next};
        }
        window.document.title = title;

        publishEvent(ANALYTIC_EVENTS.PAGEVIEW_INFINITE, {
          page_url: url,
          page_title: title,
          ...newAnalyticsData
        });

        if (sendEventPage && id) {
          handleSendVisitPage({
            onSend: sendEventPage,
            $article: change.target,
            id
          });
        }
      }
    }
  });
}, {rootMargin: '-33% 0px -33% 0px'});
